import { css, useTheme } from '@emotion/react';

interface CloseButtonProps {
  onCloseClick: () => void;
}

export default function CloseButton({ onCloseClick }: CloseButtonProps) {
  const theme = useTheme();
  return (
    <div
      css={css`
        span {
          padding: 11px 8px 11px 8px;
          color: ${theme.content.hierarchy3};
          ${theme.fontStyle.label.button16_medium};
          cursor: pointer;
        }
      `}
    >
      <span onClick={onCloseClick}>Cancel</span>
    </div>
  );
}
